exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-vertical-adapt-layout{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.fct-vertical-adapt-layout>.layout-item{-ms-flex-negative:0;flex-shrink:0}.fct-vertical-adapt-layout>.layout-item.layout-full-item{-ms-flex-positive:1;flex-grow:1}.fct-vertical-adapt-layout._stretch{-ms-flex-align:stretch;align-items:stretch}.fct-vertical-adapt-layout._left{-ms-flex-align:start;align-items:flex-start}.fct-vertical-adapt-layout._center{-ms-flex-align:center;align-items:center}.fct-vertical-adapt-layout._right{-ms-flex-align:end;align-items:flex-end}.fct-vertical-adapt-layout>*{position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/adapt/VerticalAdaptLayout.less
// module id = 169
// module chunks = 0